import React from 'react';
import {graphql, navigate} from 'gatsby';
import SEO from '@components/SEO';
import Hero from '@components/Hero';
import {Col, Divider, Grid, Row} from '@components/Grid';
import Layout from '@components/Layout';
import styles from '../stay/styles.module.scss';
import Card from '@components/Card';
import CallToActions from '@components/CallToActions';
import { bySoonestFlexibleDate } from '@helpers/dates';

const Packages = ({
    data: {
        page: {
            frontmatter: { title, description, image, callToActions },
        },
        packages: { edges: packages },
    },
}) => {
    const sortedPackages = [...packages].sort(
        ({ node: { frontmatter: a } }, { node: { frontmatter: b } }) =>
            bySoonestFlexibleDate(a.date, b.date)
    );

    return (
        <Layout>
            <SEO
                title="Offers | Spa Breaks Suffolk | Retreat East"
                description="Check out our latest offers for our spa breaks in suffolk and more. From couples spa break offers to spa breaks with the girls, we've got you covered."
            />
            <Hero image={image} imageFullWidth imageStyle={{ objectPosition: '50% 100%' }}>
                <h1>{title}</h1>
                {!!description && <p>{description}</p>}
            </Hero>

            <Grid>
                <Row>
                    {sortedPackages.map(
                        ({
                            node: {
                                frontmatter: { path, title, description, images },
                            },
                        }) => (
                            <Col xs={12} md={6} key={title}>
                                <div className={styles.package}>
                                    <Card
                                        className={styles.packageCard}
                                        onClick={() => navigate(path)}
                                    >
                                        <Card.Image
                                            height={280}
                                            fluid={images[0].childImageSharp.fluid}
                                        />
                                        <Card.Title multiLine>{title}</Card.Title>
                                        <Card.Content>
                                            <p>{description}</p>
                                        </Card.Content>
                                    </Card>
                                </div>
                            </Col>
                        )
                    )}
                </Row>
            </Grid>

            <Divider />

            {callToActions && (
                <CallToActions>
                    {callToActions.map(callToAction => (
                        <CallToActions.CallToAction key={callToAction.title} {...callToAction} />
                    ))}
                </CallToActions>
            )}
        </Layout>
    );
};

export default Packages;

export const query = graphql`
    query($path: String!) {
        page: markdownRemark(frontmatter: { path: { eq: $path } }) {
            frontmatter {
                title: offers_title
                description: offers_description
                image: offers_image {
                    childImageSharp {
                        fluid(maxWidth: 1920) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
                callToActions: offers_call_to_actions {
                    title: offers_call_to_actions_title
                    description: offers_call_to_actions_description
                    buttonText: offers_call_to_actions_button_text
                    buttonLink: offers_call_to_actions_button_link
                    image: offers_call_to_actions_image {
                        childImageSharp {
                            fluid(maxWidth: 1200) {
                                ...GatsbyImageSharpFluid
                            }
                        }
                    }
                }
            }
        }
        packages: allMarkdownRemark(
            sort: { fields: [frontmatter___package_title], order: ASC }
            filter: { fileAbsolutePath: { regex: "/data/offers/(?!.md$)/" } }
        ) {
            edges {
                node {
                    frontmatter {
                        path
                        title: package_title
                        description: package_description
                        date: package_date
                        images: package_images {
                            childImageSharp {
                                fluid(maxWidth: 560) {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
